import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatTooltip } from '@angular/material/tooltip';
import { ReminderDialogComponent } from '@app/shared/components/dialog/reminder-dialog/reminder-dialog.component';
import { ReactiveDialogService } from '@app/shared/services/ui/reactive-dialog.service';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { Reminder } from '@o30/entities';

@UntilDestroy()
@Component({
  selector:    'app-reminder',
  templateUrl: './reminder.component.html',
  styleUrls:   [],
  standalone:  true,
  imports:     [
    MatIconButton,
    MatTooltip,
    MatIcon
  ]
})
export class ReminderComponent {
  reactiveDialogService = inject(ReactiveDialogService);

  @Input()
  polizzeId: number;
  @Input()
  reminder: Reminder;

  @Output() reminderChange = new EventEmitter<Reminder>();

  get hasReminder() {
    return !!this.reminder;
  }

  get icon() {
    return this.hasReminder
      ? 'notifications_active'
      : 'notifications';
  }

  get tooltip() {
    return this.hasReminder
      ? 'Erinnerung bearbeiten'
      : 'Erinnerung setzen';
  }

  openReminderDialog() {
    const config = {
      data:     {
        title: this.tooltip
      },
      maxWidth: '800px'
    };
    this.reactiveDialogService.open(ReminderDialogComponent, config, this.reminder, this.polizzeId)
      .afterClosed()
      .pipe(untilDestroyed(this))
      .subscribe(_dialogResult => {
        if (_dialogResult && _dialogResult.status === 'success') {
          this.reminder = _dialogResult.data;
          this.reminderChange.emit(this.reminder);
        }
      });
  }

}
